<template>
  <div>
    <component
      :is="field.fieldType"
      v-for="(field, index) in schema"
      :key="index"
      :value="formData[field.name]"
      v-bind="field"
      class="mb-1"
      @input="updateForm(field.name, $event)"
    ></component>
  </div>
</template>

<script>
import Vue from 'vue'
import NumberInput from '@components/forms/NumberInput.vue'
import SelectList from '@components/forms/SelectInput.vue'
import TextInput from '@components/forms/TextInput.vue'
import Checkbox from '@components/forms/Checkbox.vue'
import MultiSelect from '@components/forms/MultiSelect.vue'
export default {
  name: 'FormGenerator',
  components: { NumberInput, SelectList, Checkbox, TextInput, MultiSelect },
  props: {
    schema: {
      type: Array,
      required: true,
    },
    value: {
      type: [String, Array, Object],
      default: null,
    },
  },
  data() {
    return {
      formData: this.value || {},
    }
  },

  methods: {
    updateForm(fieldName, value) {
      if (value.length > 0 || value === true || value === false) {
        this.$set(this.formData, fieldName, value)
      } else {
        Vue.delete(this.formData, fieldName)
      }

      this.$emit('input', this.formData)
    },
  },
}
</script>
